// src/Comman Components/Pinterest Componets/PinImage.js

import React from 'react';
import { useSelector } from 'react-redux';
import { Tooltip } from 'antd';

export default function PinImage({ Id }) {
  const profileDetails = useSelector(state => state.groups.profileDetails[Id]);

  if (!profileDetails) {
    return <div className="w-9 h-9 rounded-full bg-gray-200 animate-pulse"></div>;
  }

  if (profileDetails.error === 'TOKEN_INVALID') {
    return (
      <Tooltip title="Connection requires refresh.">
        <div className="w-9 h-9 rounded-full bg-red-100 flex items-center justify-center">
          <i className="fa-solid fa-triangle-exclamation text-red-500"></i>
        </div>
      </Tooltip>
    );
  }

  const imageUrl = profileDetails.profile_image;

  if (!imageUrl) {
    return (
      <div className="w-9 h-9 rounded-full bg-gray-300 flex items-center justify-center">
        <i className="fa-solid fa-user-slash text-gray-500 text-sm"></i>
      </div>
    );
  }

  return <img src={imageUrl} className='post_header_img' alt="Pinterest profile" />;
}